export default __webpack_public_path__ + "f4c7ae9bc717c9e323d8eb4aadfebfe3.svg";